import _toNumber from 'lodash/toNumber'
import _toString from 'lodash/toString'

import { CURRENCY, CURRENCY_SYMBOL, DEFAULT_LOCALE } from '../constants'

export const capitalizeFirstLetter = (string) => (string ? string.charAt(0).toUpperCase() + string.slice(1) : '')

export const hexToRgbA = (hex, opacity = 1) => {
    let c
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('')
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = `0x${c.join('')}`

        return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')},${opacity})`
    }
    throw new Error('Bad Hex')
}

export const fromString = (string) => {
    if (string === 'true') return true
    if (string === 'false') return false
    if (Number(string) > 0 || Number(string) === 0) return Number(string)
    return string
}

export const formatCurrency = (value) => {
    let updatedValue = _toNumber(value)

    if (_toString(updatedValue).indexOf('.') > -1) {
        updatedValue = updatedValue.toFixed(2)
    }

    if (updatedValue) {
        updatedValue = updatedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }

    return `${CURRENCY_SYMBOL}${updatedValue}`
}

export const truncateTextMiddle = (string, outputLength = 18, separator = '...') => {
    if (string.length <= outputLength) return string

    const charsToShow = outputLength - separator.length
    const frontChars = Math.ceil(charsToShow / 2)
    const backChars = Math.floor(charsToShow / 2)

    return string.substr(0, frontChars) + separator + string.substr(string.length - backChars)
}

export const formatPercentage = (string) => `${string || 0}%`
export const removeDoubleSlashes = (value = '') => value.replace(/([^:]\/)\/+/g, '$1') || ''

const withoutSpaces = (string) => string.replace(/\s/g, '')
const withoutMeaninglessDecimals = (string) => string.replace('.00', '')

const getCurrencySymbol = (currency) => {
    const CURRENCIES_SYMBOLS = {
        EUR: '€',
        GBP: '£',
        USD: '$',
    }
    return CURRENCIES_SYMBOLS[currency] ?? currency
}

const currencyFormatter =
    (formatter) =>
    (value, { currency = CURRENCY } = {}) => {
        let intlFormatter
        try {
            intlFormatter = new Intl.NumberFormat(DEFAULT_LOCALE, {
                style: 'currency',
                currency,
                currencyDisplay: 'narrowSymbol',
            })
        } catch {
            intlFormatter = {
                format: (number) => `${(number ?? 0).toFixed(2)}${getCurrencySymbol(currency)}`,
            }
        }
        return formatter(intlFormatter.format(value))
    }
export const formatCurrencyWithDecimals = currencyFormatter(withoutSpaces)

export const formatCurrencyInternational = (value, options) => {
    const formattedValue = currencyFormatter(withoutSpaces)(value, options)

    return withoutMeaninglessDecimals(formattedValue)
}
